import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Rend toute la ligne d'un tableau cliquable (data-clickable-row-url-value),
// sans casser les liens et boutons présents dans la ligne.
// Connects to data-controller="clickable-row"
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.element.classList.add("cursor-pointer");
  }

  visit(event) {
    if (event.target.closest("a, button, form, input, label")) return;

    Turbo.visit(this.urlValue);
  }
}
